import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPropertyBrief } from '../interfaces/property-brief.interface';
import { REPORT_PROPERTY, CLAIM_PROPERTY, VERIFY_OWNERSHIP, PROPERTY } from '../endpoints';

// Interface for report payload
export interface IPropertyReport {
  propertyId: string;
  text: string;
}

// Interface for property owner stats
export interface IPropertyOwnerStats {
  totalAds: number;
  totalViews: number;
  totalFavorite: number;
}

// Interface for verification request
export interface IVerificationRequest {
  propertyId: number;
  verificationType: 'email' | 'phone';
  contactValue: string;
  deleteAfterConfirmation: boolean;
}

// Interface for OTP verification
export interface IOtpVerification {
  phone: string;
  code: string;
}

@Injectable({
  providedIn: 'root',
})
export class PropertyComplaintService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Get property details by ID
   */
  public getPropertyDetails(propertyId: string): Observable<IPropertyBrief> {
    return this.http.get<IPropertyBrief>(`${PROPERTY}/${propertyId}`);
  }

  /**
   * Report a property listing issue
   */
  public reportProperty(data: IPropertyReport): Observable<any> {
    return this.http.post(REPORT_PROPERTY, data);
  }

  /**
   * Get property owner statistics
   */
  public getPropertyOwnerStats(propertyId: string): Observable<IPropertyOwnerStats> {
    return this.http.get<IPropertyOwnerStats>(`${CLAIM_PROPERTY}/${propertyId}/stats`);
  }

  /**
   * Request verification code via email or phone
   */
  public requestVerificationCode(data: IVerificationRequest): Observable<any> {
    return this.http.post(VERIFY_OWNERSHIP, data);
  }

  /**
   * Verify ownership with OTP
   */
  public verifyWithOtp(data: IOtpVerification): Observable<any> {
    return this.http.post(`${VERIFY_OWNERSHIP}/verify`, data);
  }
}
